import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-xhm-slot-desk",
  "use": "icon-soc-xhm-slot-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-xhm-slot-desk\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"160\" y=\"288\" width=\"192\" height=\"448\" rx=\"24\" /><rect x=\"416\" y=\"224\" width=\"192\" height=\"512\" rx=\"24\" /><rect x=\"672\" y=\"288\" width=\"192\" height=\"448\" rx=\"24\" /><path d=\"M192 192h128v64H192zM448 160h128v64H448zM704 192h128v64H704z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-xhm-slot-desk.svg
// module id = +krl
// module chunks = 492